export const RBM_TRANSPORTER_NAMES = Object.freeze([
  '0882',
  'ACPL',
  'ARC TRANSPORT',
  'ARCL',
  'ARCO',
  'ARJUN',
  'ASHISH TATA ACE',
  'AVINASH / AKASH AVAD TEMPO',
  'BATCOTRANS LOGISTICS PVT. LTD.',
  'BHAVNA ROAD WAYS',
  'BHOSALE TRANSPORT',
  'BULK',
  'ECOPACK SERVICES PVT. LTD.',
  'G.K. TRANSPORT',
  'GAIKWAD CRANE SERVICE',
  'HARI OM PACKERS AND MOVERS',
  'JAGRITI TRANSPORT',
  'JAYRAM TRANSLINK PVT. LTD.',
  'KRS TRANSPORT',
  'MAA FREIGHT CARRIER',
  'MAHEH RIKSHA',
  'MARUTI',
  'MATA ANNAPURNA',
  'MR. SUMIT',
  'NAVATA TRANSPORT',
  'OPTION TRANSPORT PRIVATE LIMITED',
  'Pole contractor',
  'Pole Contractor Superwiser',
  'PORTER',
  'PRABHAT TRANSPORT / RAM ROADLINES',
  'PRATIK ROADLINES',
  'RAJLAXMI TRANS LOGISTICS',
  'RAVIAC-PL',
  'Raviraj Roadline KOLHAPUR / AURANGABAD / NASHIK',
  'S K ROADLINES',
  'SAFE & SECURE LOGISTICS PRIVATE LIMITED',
  'SARCO ROADLINES PRIVATE LIMITED',
  'SATNA EXPRESS',
  'Sayyad Wireman',
  'SCORPION EXPRESS PRIVATE LIMITED',
  'SELF',
  'SHARAD',
  'Shutter fabricator',
  'SKE SUPPLY CHAIN SOLUTIONS',
  'SMART N LOGISTICS SERVICE',
  'SUGAM PARIVAHAN PRIVATE LIMITED',
  'Suhas Darshale Jcb',
  'Sukhraj And Company CRANE SERVICE',
  'SURESH SOLANKI',
  'TCI EXPRESS',
  'TCI FREIGHT',
  'V TRANS',
  'VISHVAJEET EXPRESS SERVICE',
  'VRL LOGISTICS LIMITED',
] as const);

export type RbmTransporterName = typeof RBM_TRANSPORTER_NAMES[number];

export function mergeTransporterNames(masterNames: Array<string | undefined | null> = []) {
  const seen = new Set<string>();
  const merged: string[] = [];
  for (const raw of [...masterNames, ...RBM_TRANSPORTER_NAMES]) {
    const name = String(raw || '').trim();
    const key = name.toUpperCase().replace(/\s+/g, ' ');
    if (!name || seen.has(key)) continue;
    seen.add(key);
    merged.push(name);
  }
  return merged.sort((a, b) => a.localeCompare(b, 'en-IN', { sensitivity: 'base' }));
}
